import React from 'react';
import {TextBlock, RectShape} from "react-placeholder/lib/placeholders";

let iconImagePath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-image.svg`;
export const  sectionPlaceholder = <div style={{display: 'flex'}}>
        <img src={iconImagePath} style={{marginRight: '10px', height: '80px'}} alt=''/>
        <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
    </div>;

let iconBlockPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-2.svg`;
export const  sectionBlockPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconBlockPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconPricesPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-4.svg`;
export const  sectionPricesPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconPricesPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconReviewsPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-7.svg`;
export const  sectionReviewsPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconReviewsPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconMapPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-3.svg`;
export const  sectionMapPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconMapPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconFormPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-5.svg`;
export const  sectionFormPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconFormPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconHtmlPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-6.svg`;
export const  sectionHtmlPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconHtmlPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconPartnersPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-8.svg`;
export const  sectionPartnersPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconPartnersPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

let iconItineraryPath = process.env.PUBLIC_URL + `/assets/pagebuilder/element-1.svg`;
export const  sectionItineraryPlaceholder = <div style={{display: 'flex'}}>
    <img src={iconItineraryPath} style={{marginRight: '10px', height: '80px'}} alt=''/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;

export const  sectionProjectsPlaceholder = <div style={{display: 'flex', alignItems: 'center'}}>
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
    <RectShape className="textBlockPlaceholder" color='#f0f0f0' style={{width: 200, height: 80}}/>
    <TextBlock className="textBlockPlaceholder" rows={5} color={'#f0f0f0'} />
</div>;




// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_placeholder.js